import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { updateUserInfoAction } from './actions';
import { User } from '../../../models/User';

export interface UserState {
  data: User;
  loaded: boolean;
}

const initialState: UserState = {
  data: {
    userId: ''
  },
  loaded: false
};

const reducer = reducerWithInitialState(initialState)
  .case(updateUserInfoAction, (state, param: User) => {
    return { data: { ...param }, loaded: true };
  })
;

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/user/reducers.ts